import styled from "styled-components";
import {Text1} from "../../../styles/components";

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1356px;
`

export const Content = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const MobileContent = styled.div`
  padding: 20px;
  
  & svg {
    margin-top: 20px;
    width: auto;
    height: 300px;
  }
  
  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    display: block;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    display: none;
  }
`

export const Block = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex-shrink: 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    gap: 40px;
    width: 800px;
  }
`

export const ImageBlock = styled.div`
  
`

export const SupportText = styled(Text1)`
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`

export const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 25px;
  
  & button {
    width: 33%;
    text-align: center;
    padding: 10px;
  }
  
  @media only screen and (${({theme}) => theme.media.small}) {
    & button {
      width: 33%;
      gap: 2rem;
    }
  }
`